import React from 'react';
import { Loader } from '../../../../Loader';
import { SessionNoteModalBody, useClinicalNotesModal } from '../../clinical-notes-modal';
import { LightChip } from '../../../../LightChip';
import { useAddendaBySessionIdQuery, useAppointmentByIdQuery, useSessionByAppointmentIdQuery } from '@uplift/queries';


export const AddendaTitleChip: React.VFC<{ sessionId: string }> = (props) => {
  const { data } = useAddendaBySessionIdQuery(props.sessionId);

  if (data?.length) {
    if (data?.length > 1) {
      return <LightChip label="with Addenda" size="small" color="lightGrey" labelWeight="thin" />;
    }
    return <LightChip label="with Addendum" size="small" color="lightGrey" labelWeight="thin" />;
  }

  return null;
};


export type SessionClinicalNotesReviewProps = {
  appointmentId: string;
  patientId: string;
};


export const SessionClinicalNotesReview: React.FC<SessionClinicalNotesReviewProps> = (props) => {
  const { state } = useClinicalNotesModal(props.appointmentId);
  const { data: session } = useSessionByAppointmentIdQuery(props.appointmentId);
  const { data: appointment } = useAppointmentByIdQuery(props.appointmentId);

  if (!state || !session || !appointment) return <Loader />;

  return (
    <SessionNoteModalBody
      state={state}
      session={session}
      appointment={appointment}
      appointmentId={props.appointmentId}
      patientId={props.patientId}
    />
  );
};
